import React, {useState} from 'react';

import "./AgeConfirmed.scss";
import {updateCurrentUser, USER_CURRENT_KEY} from "../../../api/public-voissa/users";
import _ from "lodash";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import moment from "moment/moment";
import {DateInputFieldBirthdaySelect} from "../FormField";
import {Button} from "../Button";
import {toastError, toastSuccess} from "../../../libs/toast";
import {CURRENT_USER} from "../../../const/toasts";
import argument1 from "../../components2/encourageSignup/images/argument-1.png";
import argument2 from "../../components2/encourageSignup/images/argument-2.png";
import argument3 from "../../components2/encourageSignup/images/argument-3.png";
import Icon from "../Icon";
import {config} from "../../../config";




const AgeConfirmed = () => {
    const queryClient = useQueryClient();
    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    const isToggle = isCurrentUser ? !!moment().diff(moment(dataCurrentUser.createdAt), 'days') >= 1 : false;

    let date = _.get(dataCurrentUser,'profile.informations[0].birthday') || null;
    let date2 = _.get(dataCurrentUser,'profile.informations[1].birthday') || null;
    let sex =  _.get(dataCurrentUser,'profile.informations[0].sex') || 0;
    let sex2 =  _.get(dataCurrentUser,'profile.informations[1].sex') || 0;
    let currentGender = _.get(dataCurrentUser,'profile.gender') || 0;
    const [dateBirthday, setDateBirthday] = useState(date);
    const [dateBirthday2, setDateBirthday2] = useState(date2);
    let isCouple = [3,4,5].includes(currentGender);

    const {
        mutate : mutateUpdateUser,
    } = useMutation(data => updateCurrentUser(data),{
        onSuccess: async () =>{
            toastSuccess(CURRENT_USER.SUCCESS.UPDATE);
            //await refetchCurrentUser();
            await queryClient.invalidateQueries([USER_CURRENT_KEY]);
        },
        onError: () =>{
            toastError(CURRENT_USER.ERROR.UPDATE);
        }
    });

    function onSubmit(){
        let informations = _.get(dataCurrentUser,'profile.informations') || [];
        if(informations.length) {
            informations[0].birthday = dateBirthday;
            if (isCouple && informations.length >= 2) {
                informations[1].birthday = dateBirthday2;
            }

            let currentUser = {
                ...dataCurrentUser,
                profile: {
                    ...dataCurrentUser.profile,
                    informations
                }
            };
            if (dateBirthday !== null || (isCouple && dateBirthday2 !== null)) {
                mutateUpdateUser(currentUser);
            }
        }

    }

    return isToggle && (date === null || (isCouple && date2 === null)) ? (
        <div id={"age-confirmed"}>
            <div className="full-bg"></div>
            <div className="center">
                <div className="container-signup">
                    <div className="window-wrapper">
                        <div className="window">
                            <div className="illustration"></div>
                            <div className="main-section">
                                <div className="form">
                                    <h2>De quelle génération êtes-vous ?</h2>
                                    <h3>Nous avons besoin de connaître l'âge approximatif des membres.</h3>
                                    <ul className="arguments">
                                        <li>
                                            <div className="icon">
                                                <img alt={""} src={argument1} />
                                            </div>
                                            <label>Votre date de naissance est privée.</label>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <img alt={""} src={argument2} />
                                            </div>
                                            <label>Seule une tranche d'âge apparaîtra sur votre profil (exemple 36-40 ans).</label>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <img alt={""} src={argument3} />
                                            </div>
                                            <label>Vous pouvez changer l'information dans votre profil à tout moment.</label>
                                        </li>
                                    </ul>
                                    <ul className={"birthday"}>
                                        <li>
                                            {isCouple ? <div
                                                 className={`flex-table-head-title ${sex === 0 ? 'him' : sex === 1 ? 'her' : ''}`}>
                                                <Icon type={config.genderClassProfile[sex]}/>
                                                {sex === 0 ? (
                                                    "Lui"
                                                ) : sex === 1 && (
                                                    "Elle"
                                                )}
                                            </div> : null}
                                            <DateInputFieldBirthdaySelect
                                                birthday={dateBirthday}
                                                updateBirtday={(date) => setDateBirthday(date)}
                                            />
                                        </li>

                                        {isCouple ? (
                                            <li>
                                                <div
                                                    className={`flex-table-head-title pt-8 ${sex2 === 0 ? 'him' : sex2 === 1 ? 'her' : ''}`}>
                                                    <Icon type={config.genderClassProfile[sex2]}/>
                                                    {sex2 === 0 ? (
                                                        "Lui"
                                                    ) : sex2 === 1 && (
                                                        "Elle"
                                                    )}
                                                </div>
                                                <DateInputFieldBirthdaySelect
                                                    birthday={dateBirthday2}
                                                    updateBirtday={(date) => setDateBirthday2(date)}
                                                />

                                            </li>

                                        ) : null}
                                    </ul>
                                    <div className="cta-list">
                                        <Button
                                            size={"small"}
                                            btnStyle={"primary-reverse"}
                                            className={"signup-cta"}
                                            onClick={() => onSubmit()}
                                            disabled={moment().diff(moment(dateBirthday) , 'year') < 18 || (isCouple && moment().diff(moment(dateBirthday2) , 'year') < 18)}
                                            content={"Enregistrer"}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : null
};

export default AgeConfirmed;